import { render, staticRenderFns } from "./SvOnSupport.vue?vue&type=template&id=67ce8201"
import script from "./SvOnSupport.vue?vue&type=script&lang=js"
export * from "./SvOnSupport.vue?vue&type=script&lang=js"
import style0 from "./SvOnSupport.vue?vue&type=style&index=0&id=67ce8201&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports